import { render, staticRenderFns } from "./Pform.vue?vue&type=template&id=26549bfe&scoped=true&"
import script from "./Pform.vue?vue&type=script&lang=js&"
export * from "./Pform.vue?vue&type=script&lang=js&"
import style0 from "./Pform.vue?vue&type=style&index=0&id=26549bfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26549bfe",
  null
  
)

export default component.exports